import { Messages } from '@asayerio/tracker';
export default function () {
    return (app) => {
        if (app === null) {
            return (_1, _2, _3, result) => result;
        }
        return (operationKind, operationName, variables, result) => {
            if (typeof operationKind !== 'string' || typeof operationName !== 'string') {
                return result;
            }
            try {
                app.send(Messages.GraphQL(operationKind || "query", operationName || "", JSON.stringify(variables), JSON.stringify(result)));
            }
            finally {
                return result;
            }
        };
    };
}
